import { render } from "./TramitesPorFecha.vue?vue&type=template&id=1c6c40fa&scoped=true"
import script from "./TramitesPorFecha.vue?vue&type=script&lang=js"
export * from "./TramitesPorFecha.vue?vue&type=script&lang=js"

import "./TramitesPorFecha.vue?vue&type=style&index=0&id=1c6c40fa&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6c40fa"]])

export default __exports__